import {
    clientAddContactBaseSchema,
    clientAttachContactBaseSchema,
    clientCreate,
    clientUpdateContactProfileBaseSchema,
    clientUpdateProfileBaseSchema,
    MAX_INPUT_FIELD_LENGTH as MAX_LENGTH,
    MAX_CONTACT_NOTES_LENGTH as MAX_NOTES_LENGTH,
} from '@nesso/client-contracts/client.commands';
import {
    getClientById,
    getClientContactCandidates,
    getClientContacts,
    getClientCount,
    getClientList,
    getClientPerson,
    getClientProfile,
    getClientRelationships,
    getContactProfile,
} from '@nesso/client-contracts/client.queries';

import { rejectEmptyPronouns } from '@/shared/lib/reject-empty-pronouns';

export const createClientOutputSchema = clientCreate.output;
export const getClientByIdOutputSchema = getClientById.output;
export const getClientContactCandidatesOutputSchema = getClientContactCandidates.output;
export const getClientContactsOutputSchema = getClientContacts.output;
export const getClientCountOutputSchema = getClientCount.output;
export const getClientListOutputSchema = getClientList.output;
export const getClientPersonOutputSchema = getClientPerson.output;
export const getClientProfileOutputSchema = getClientProfile.output;
export const getClientRelationshipsOutputSchema = getClientRelationships.output;
export const getContactProfileOutputSchema = getContactProfile.output;

export const createClientInputSchema = clientCreate.input.omit({
    practiceId: true,
    practiceMemberId: true,
});

export const addClientInputSchema = createClientInputSchema.superRefine(rejectEmptyPronouns);

// Derived from the unrefined base because zod rejects `.omit()` on a schema carrying refinements.
export const updateClientProfileInputSchema = clientUpdateProfileBaseSchema.omit({
    practiceId: true,
    practiceMemberId: true,
});

// Unrefined base for the same reason as the client profile's.
export const updateContactProfileInputSchema = clientUpdateContactProfileBaseSchema.omit({
    practiceId: true,
    practiceMemberId: true,
});

// Derived from the unrefined base for the same reason as the profile: zod cannot `.omit()` once a
// schema carries refinements, and the add-contact contract has none to re-apply.
export const addClientContactInputSchema = clientAddContactBaseSchema.omit({
    id: true,
    practiceId: true,
    practiceMemberId: true,
});

// The names are not here: the person's are locked on the Existing contact tab and the server reads
// them, so this body cannot rename anybody.
export const attachClientContactInputSchema = clientAttachContactBaseSchema.omit({
    id: true,
    practiceId: true,
    practiceMemberId: true,
});

export const MAX_INPUT_FIELD_LENGTH = MAX_LENGTH;
export const MAX_CONTACT_NOTES_LENGTH = MAX_NOTES_LENGTH;
